export interface ICommitteeHistoryDto {
  committee: string;
  changeRecordHistoryId: string;
  fullName: string | null;
  changeField: string;
  originalValue: string;
  newValue: string;
  lastModifiedDate: string;
}

export interface ICommitteeHistoryDtoWithDescription {
  committee: string;
  changeRecordHistoryId: string;
  fullName: string | null;
  changeField: string;
  originalValue: string;
  newValue: string;
  lastModifiedDate: string;
  description: string;
  committeeCode: string;
}


export enum CommitteeUpdateRoles {
  ProjectManager = "Lead",
  ProgramManager = "Manager",
  EngagementManager = "National Manager"
}

export enum CommitteeUpdateRoleStatus {
  RoleStatus = "Role Status",
  AwaitingAssignment = "Awaiting Assignment",
  ParticipatingMember = "Participating Member",
  Former = "Former",
  Current = "Current"
}

export const CommitteeMemberRoles = {
  ParticipatingMember: "Participating Member",
  Chairperson: "Chairperson",
  ChairpersonElect:"Chairperson Elect",
  CoOpted: "Co-Opted",
  ForInformationOnly: "For Information Only",
  ExOfficio: "Ex-Officio"  
};

